import formatNodes from 'modules/Node/helpers/formatNodes'
import { bootstrapQuery } from 'utils/queries'
import buildNodeHierarchy from 'utils/buildNodeHierarchy'

export default async ({ graphql, state, path }) => {
  const result = await graphql.query(bootstrapQuery())
  const { client, user, targets } = result
  if (!user || !client) {
    return path.loggedOut()
  }

  return path.loggedIn({
    nodes: formatNodes(buildNodeHierarchy(result.nodesFlatten)),
    user,
    client,
    targets
  })
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/bootstrap.js